module.exports = {
  400: 'Please fill in all mandatory fields.',
  404: 'The requested action was not found.',
  401: 'You are not authorized for this action.',
  acceptTerms: 'You have to accept our general terms and conditions',
  emailNotFound: 'Your email address can not be found.',
  fillAllFields: 'Please fill in all mandatory fields.',
  general: 'Something went wrong. Please try again later.',
  invalidCredentials: 'Your email and password do not match our records',
  invalidPassword: 'Your current password does not match our records',
  maintenance: {
    description: 'This service is currently unavailable. Please try again later.',
    title: 'Maintenance',
  },
  page: {
    description: 'Oops, something went wrong. We could not find the requested page.',
    title: 'Page not found',
  },
  validation: {
    email: 'This is not a valid email.',
    min: {
      string: 'This should be at least 6 characters long.',
    },
    required: 'This field is required.',
  },
  systemDefinition: {
    lessControllersThanCircuits: 'There are less controllers than circuits',
  },
};



// WEBPACK FOOTER //
// ./js/lang/en/errors.js